export const AuthorizedSignatureOptions = [
    { label: "JACINTO", value: "JACINTO" },
    { label: "RINA CRUZ", value: "RINA CRUZ"},
    { label: "NOEL LIM", value: "NOEL LIM"},
    
  ];

 